export function isActive(active: boolean): string {
  return active ? 'Ativo' : 'Inativo';
}

export function isBlocked(blocked: boolean): string {
  return blocked ? 'Bloqueado' : 'Desbloqueado';
}
